// ============================================================================
// CHAIR
// ============================================================================

import CONFIG from '../config.js';

export class Chair {
    constructor(x, y, physics = null) {
        this.x = x;
        this.y = y;
        this.width = 30;
        this.height = 40;
        this.physics = physics;
        
        if (physics) {
            this.body = physics.createRectangle(x, y, this.width, this.height, {
                isStatic: true,
                frictionAir: 0,
                friction: 0,
                restitution: 0
            });
            physics.linkEntity(this, this.body);
        } else {
            this.body = null;
        }
    }
    
    update(dt) {
        if (this.body) {
            this.x = this.body.position.x;
            this.y = this.body.position.y;
        }
    }

    draw(ctx, camera) {
        ctx.save();

        const drawX = this.x;
        const drawY = this.y;

        // --- 3/4 PERSPECTIVE SETTINGS ---
        const depth = 6;
        const heightOffset = 35;

        const darkerColor = '#4B3621';
        const topColor = '#8B6F47';
        const seatColor = '#8B4513';
        const backColor = '#654321';

        // 1. Draw SIDE/THICKNESS
        ctx.fillStyle = darkerColor;
        ctx.fillRect(drawX - this.width / 2, drawY - this.height / 2 - heightOffset, this.width, this.height + heightOffset);

        // 2. Draw TOP SURFACE (seat top)
        ctx.fillStyle = topColor;
        ctx.fillRect(drawX - this.width / 2, drawY - this.height / 2 - heightOffset, this.width, depth);
        ctx.strokeStyle = '#000';
        ctx.strokeRect(drawX - this.width / 2, drawY - this.height / 2 - heightOffset, this.width, depth);

        // 3. Draw FRONT FACE
        const frontY = drawY - this.height / 2 - heightOffset + depth;
        const frontHeight = this.height + heightOffset - depth;

        // Chair back (taller part)
        ctx.fillStyle = backColor;
        ctx.fillRect(drawX - this.width / 2, frontY, this.width, 20);
        ctx.strokeStyle = '#000';
        ctx.lineWidth = 2;
        ctx.strokeRect(drawX - this.width / 2, frontY, this.width, 20);

        // Back rest detail
        ctx.fillStyle = '#8B6F47';
        ctx.fillRect(drawX - this.width / 2 + 3, frontY + 2, this.width - 6, 16);

        // Seat (lower part of front face)
        const seatY = frontY + 20;
        ctx.fillStyle = seatColor;
        ctx.fillRect(drawX - this.width / 2, seatY, this.width, frontHeight - 20);
        ctx.strokeRect(drawX - this.width / 2, seatY, this.width, frontHeight - 20);

        // Legs (on front face, at bottom)
        ctx.fillStyle = darkerColor;
        const legWidth = 4;
        const legHeight = 8;
        ctx.fillRect(drawX - this.width / 2 + 4, seatY + frontHeight - 20 - legHeight, legWidth, legHeight);
        ctx.fillRect(drawX + this.width / 2 - 8, seatY + frontHeight - 20 - legHeight, legWidth, legHeight);

        ctx.restore();
    }
}
